<template>
  <div>
    <headTop></headTop>
    <div class="cssOrderdetail">
      <div class="cssOrderdetailMapping">
        <span class="cssOrderdetailTitle">应急保障</span>
        <span class="cssOrderdetailSubTitle">— 订单支付</span>
        <!-- <div class="cssBack" @click="$router.back(-1)">返回上一步 ></div> -->
      </div>

      <!-- <div class="cssOrderInfo">
          <p class="cssOrderInfoTit">订单信息</p>
          <p class="cssOrderInfoDetail">订单号：</p><span class="cssInnerText">{{orderdetail.order_id}}</span>
          <p class="cssOrderInfoDetail">订单时间：</p><span class="cssInnerText">{{orderdetail.created_time}}</span>
          <p class="cssOrderInfoDetail">安保费：</p><span class="cssInnerText">{{orderdetail.security_money}}</span>
          <p class="cssOrderInfoDetail">消防车租凭费：</p><span class="cssInnerText">{{orderdetail.car_rental_money}}</span>
          <p class="cssOrderInfoDetail">方案总价：</p><span class="cssInnerText">{{orderdetail.count_money}}</span>
          <p class="cssOrderInfoDetail">付款时间：</p><span class="cssInnerText">{{formatTime(orderdetail.tails.payOrder.pay_time) || '-'}}</span>
          <p class="cssOrderInfoDetail">支付方式：</p><span class="cssInnerText">{{orderdetail.tails.payOrder.channel || '-'}}</span>
          <p class="cssOrderInfoDetail">订单状态：</p><span class="cssInnerText">{{orderdetail.tails.payOrder.pay_state}}</span>
      </div> -->

      <div class="cssServeInfo">
        <p class="cssOrderInfoTit">服务信息</p>
        <p class="cssOrderInfoDetail">联系人：</p><span class="cssInnerText">{{orderdetail.user_name || '-'}}</span>
        <p class="cssOrderInfoDetail">联系人手机号：</p><span class="cssInnerText">{{orderdetail.phone || '-'}}</span>
        <p class="cssOrderInfoDetail">项目地址：</p><span class="cssInnerText">{{orderdetail.logistics_match || '-'}}&nbsp;{{orderdetail.city || '-'}}&nbsp;{{orderdetail.area || '-'}}</span>
        <p class="cssOrderInfoDetail">项目详细地址：</p><span class="cssInnerText">{{orderdetail.address_detail || '-'}}</span>
      </div>
      <div class="cssNeedInfo">
        <p class="cssOrderInfoTit">需求信息</p>
        <p class="cssOrderInfoDetail">场所选择：</p><span class="cssInnerText">{{orderdetail.place || '-'}}</span>
        <p class="cssOrderInfoDetail">需求选择：</p><span class="cssInnerText">{{orderdetail.demand || '-'}}</span>
        <p class="cssOrderInfoDetail">客户属性：</p><span class="cssInnerText">{{orderdetail.customer_property || '-'}}</span>
        <p class="cssOrderInfoDetail">租赁需求：</p><span class="cssInnerText">{{orderdetail.lease_types || '-'}}</span>
        <p class="cssOrderInfoDetail">安保类型：</p><span v-if="orderdetail.security_type == 1" class="cssInnerText">单班保障</span>
        <span v-if="orderdetail.security_type == 2" class="cssInnerText">双班保障</span>
        <span v-if="orderdetail.security_type == 3" class="cssInnerText">三班保障</span>
        <p class="cssOrderInfoDetail">需求周期：</p><span class="cssInnerText">{{orderdetail.security_demand_start || '-'}} 至 {{orderdetail.security_demand_end || '-'}} 共{{orderdetail.tails.daySub_security || '-'}}天 （工作节点
          {{orderdetail.security_actual_end_date+'  '+orderdetail.work_time_end || '-'}}）</span>security_guard_num
        <p class="cssOrderInfoDetail">工作时间：</p><span class="cssInnerText">{{orderdetail.work_time_start || '-'}} - {{orderdetail.work_time_end || '-'}}</span>
        <p class="cssOrderInfoDetail">安保人数：</p><span class="cssInnerText" v-if="orderdetail.security_type == 1">{{orderdetail.security_guard_num || '-'}}位 &nbsp;&nbsp;&nbsp;单班保障共{{orderdetail.security_guard_num*orderdetail.security_type || '-'}}位/天</span>
        <span class="cssInnerText" v-else-if="orderdetail.security_type == 2">{{orderdetail.security_guard_num || '-'}}位 &nbsp;&nbsp;&nbsp;双班保障共{{orderdetail.security_guard_num*orderdetail.security_type || '-'}}位/天</span>
        <span class="cssInnerText" v-else-if="orderdetail.security_type == 3">{{orderdetail.security_guard_num || '-'}}位 &nbsp;&nbsp;&nbsp;三班保障共{{orderdetail.security_guard_num*orderdetail.security_type || '-'}}位/天</span>
        <p class="cssOrderInfoDetail">消防车租凭：</p><span class="cssInnerText">{{orderdetail.car_rental_num || '-'}}辆</span>
        <p class="cssOrderInfoDetail">需求周期：</p><span class="cssInnerText">{{orderdetail.car_rental_start || '-'}} 至 {{orderdetail.car_rental_end || '-'}} 共{{orderdetail.tails.daySub_car || '-'}}天</span>
      </div>
      <div class="cssContract">
        <p class="cssOrderInfoTit">合同签署</p>
        <img class="cssContractImg" src="">
      </div>
      <div class="cssPayBottomDetail">
        <div class="cssUparea">
          <p class="cssOrderInfoPayDetail">安保费</p><span class="cssInnerPayText">￥{{orderdetail.security_money || '-'}}</span>
          <p class="cssOrderInfoPayDetail">消防车租赁费</p><span class="cssInnerPayText">￥{{orderdetail.car_rental_money || '-'}}</span>
          <p class="cssOrderInfoPayDetail">消防车配送费</p><span class="cssInnerPayText">￥{{orderdetail.car_dispatching_money || '-'}}</span>
        </div>
        <div class="cssButtonArea">
          <span class="cssAllAmount">方案总价：<span class="cssPrice">￥{{orderdetail.count_money}}</span></span>
          <button class="cssPay" @click="applyClick(orderdetail.order_id,orderdetail.count_money)">在线支付</button>
        </div>
      </div>

      <div v-if="orderdetail.tails.payOrder.pay_state == '未付款'" class="cssBlankArea">
        <!-- 底部占位 -->
      </div>
      <!-- <bottomButton  v-if="orderdetail.tails.payOrder.pay_state == '未付款'" title="支付" :state="5"  @click="applyClick(orderdetail.order_id)"></bottomButton> -->
    </div>
    <!--  支付弹窗  -->
    <payView type="5" :show="payViewVisible" :Orderid="orderdetail.order_id" :money="orderdetail.count_money" @payValue="payValue"></payView>
    <!--  支付成功弹窗  -->
    <SuccessView :show="showSuccessView" type="2" @successViewClick="successViewClick"></SuccessView>
  </div>
</template>
<script>
import headTop from './header'
// import bottomButton from '../components/bottom-button'
import payView from '../components/pay'
import SuccessView from '../components/success-view'
export default {
  name: 'orderpaydetail',
  data () {
    return {
      showSuccessView: false,
      currentId: this.$route.query.orderid || '1187563086509244416',
      orderdetail: {
        tails: {
          payOrder: {}
        }
      },
      // url: Utils.SERVER1,
      payViewVisible: false
    }
  },
  mounted () {
    this.getData(this.currentId)
  },
  methods: {
    // 时间转化函数
    formatTime (ndate) {
      if (!ndate) {
        return '-'
      }
      var date = new Date(ndate * 1000)
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      var day = date.getDate()
      var hour = date.getHours()
      var minute = date.getMinutes()
      var second = date.getSeconds()
      if (month >= 1 && month <= 9) {
        month = '0' + month
      }
      if (day >= 0 && day <= 9) {
        day = '0' + day
      }
      if (hour >= 0 && hour <= 9) {
        hour = '0' + hour
      }
      if (minute >= 0 && minute <= 9) {
        minute = '0' + minute
      }
      if (second >= 0 && second <= 9) {
        second = '0' + second
      }
      var result =
        year +
        '-' +
        month +
        '-' +
        day +
        ' ' +
        hour +
        ':' +
        minute +
        ':' +
        second
      return result
    },

    getData (id) {
      var _this = this
      this.utils.GET(
        this.companyUrl + '/zxOrder/detailsOfSolutions?orderId=' + id,
        function (res) {
          if (res.code === 0) {
            console.log(res.data)
            _this.orderdetail = res.data
            if (_this.orderdetail.lease_types.indexOf('安保人员') !== -1) {
              _this.orderdetail.security_demand_start = _this.orderdetail.security_demand_start.split(
                ' '
              )[0]
              _this.orderdetail.security_demand_end = _this.orderdetail.security_demand_end.split(
                ' '
              )[0]
              _this.orderdetail.security_money = _this.money_dot(
                _this.orderdetail.security_money
              )
            }
            if (_this.orderdetail.lease_types.indexOf('消防车租赁') !== -1) {
              _this.orderdetail.car_rental_start = _this.orderdetail.car_rental_start.split(
                ' '
              )[0]
              _this.orderdetail.car_rental_end = _this.orderdetail.car_rental_end.split(
                ' '
              )[0]
              _this.orderdetail.car_dispatching_money = _this.money_dot(
                _this.orderdetail.car_dispatching_money
              )
              _this.orderdetail.car_rental_money = _this.money_dot(
                _this.orderdetail.car_rental_money
              )
            }
            _this.orderdetail.count_money = _this.money_dot(
              _this.orderdetail.count_money
            )
            console.log(_this.orderdetail.tails.payOrder.channel)
            if (_this.orderdetail.tails.payOrder.channel === 'remittance') {
              _this.orderdetail.tails.payOrder.channel = '线下汇款'
            }
            console.log(_this.orderdetail.tails.payOrder.channel)
            if (
              _this.orderdetail.tails.payOrder.channel === 'alipay_pc_direct'
            ) {
              _this.orderdetail.tails.payOrder.channel = '支付宝'
            }
            if (_this.orderdetail.tails.payOrder.channel === 'wx_pub_qr') {
              _this.orderdetail.tails.payOrder.channel = '微信'
            }
            console.log(_this.orderdetail)
          }
        }
      )
    },

    // 用户信息获取
    // get_data (id) {
    //   this.$api.get(this.companyUrl + '/zxOrder/detailsOfSolutions',
    //     {
    //       orderId: id
    //     },
    //     resj => {
    //       if (resj.code == 0) {
    //         this.data = resj.data
    //         if (this.data.lease_types.indexOf('安保人员') != -1) {
    //           this.has_security = true
    //           this.data.security_demand_start = this.data.security_demand_start.split(' ')[0]
    //           this.data.security_demand_end = this.data.security_demand_end.split(' ')[0]
    //           this.data.security_money = this.money_dot(this.data.security_money)
    //         }
    //         if (this.data.lease_types.indexOf('消防车租赁') != -1) {
    //           this.has_car = true
    //           this.data.car_rental_start = this.data.car_rental_start.split(' ')[0]
    //           this.data.car_rental_end = this.data.car_rental_end.split(' ')[0]
    //           this.data.car_dispatching_money = this.money_dot(this.data.car_dispatching_money)
    //           this.data.car_rental_money = this.money_dot(this.data.car_rental_money)
    //         }
    //         this.data.count_money = this.money_dot(this.data.count_money)
    //         if (this.data.tails.payOrder.channel == 'remittance') {
    //           this.data.tails.payOrder.channel = '线下汇款'
    //         }
    //         if (this.data.tails.payOrder.channel == 'alipay_pc_direct') {
    //           this.data.tails.payOrder.channel = '支付宝'
    //         }
    //         if (this.data.tails.payOrder.channel == 'wx_pub_qr') {
    //           this.data.tails.payOrder.channel = '微信'
    //         }
    //       }
    //     }
    //   )
    // },

    applyClick: function (id, amount) {
      this.payViewVisible = true
    },
    payValue: function (state) {
      this.payViewVisible = false
      if (state === 1) {
        this.showSuccessView = true
      }
      console.log('============支付回调')
    },

    successViewClick: function () {
      this.showSuccessView = false
      this.$router.go(-1)
    },
    toTop () {
      // 滚动至顶部
      // document.documentElement.scrollTop=0
      document.documentElement.scrollTop = document.body.scrollTop = 0
    },
    dataURLtoBlob (dataurl) {
      let arr = dataurl.split(',')
      let mime = arr[0].match(/:(.*?);/)[1]
      let bstr = atob(arr[1])
      let n = bstr.length
      let u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], { type: mime })
    },

    closeSucess () {
      this.sucess = false
      document.querySelector('body').style = 'overflow:auto'
    }
  },
  components: {
    headTop,
    payView,
    SuccessView
    // bottomButton
  }
}
</script>
<style scoped>
body {
  height: 100%;
  padding-bottom: 60px;
}
.header {
  position: fixed;
  top: 0px;
  height: 55px;
  width: 100%;
}
.cssOrderdetail {
  margin-top: 55px;
  font-size: 0;
  background: #f0f0f0;
}
.cssOrderdetail .cssOrderdetailMapping {
  width: 100%;
  height: 50px;
  line-height: 50px;
  padding: 0 14px 0 15px;
  background: #ffffff;
  box-sizing: border-box;
  margin-bottom: 10px;
  border-bottom: 1px solid #eeeeee;
}
.cssOrderdetail .cssOrderdetailMapping .cssOrderdetailTitle {
  font-weight: bold;
  font-size: 16px;
  color: #000;
  font-family: " MicrosoftYaHei-Bold ";
}
.cssOrderdetail .cssOrderdetailMapping .cssOrderdetailSubTitle {
  font-weight: bold;
  font-size: 14px;
  color: #000;
  font-family: " MicrosoftYaHei-Bold ";
}
.cssOrderdetail .cssOrderdetailMapping .cssBack {
  height: 30px;
  width: 77px;
  font-size: 13px;
  line-height: 30px;
  float: right;
  background: none;
  border: none;
  margin-top: 10px;
  color: #999999;
}
.cssOrderInfo {
  width: 100%;
  /* height: 363px; */
  background: #ffffff;
  padding: 20px 15px 20px 15px;
  margin: 0 0 10px 0;
  font-size: 0;
}
.cssOrderInfo .cssOrderInfoTit {
  display: block;
  height: 14.5px;
  width: 100%;
  text-align: left;
  font-family: SourceHanSansCN-Bold;
  font-weight: bold;
  color: #000;
  font-size: 15px;
  margin-bottom: 28.5px;
}

.cssOrderInfoDetail {
  vertical-align: top;
  display: inline-block;
  height: 13px;
  width: 126.5px;
  text-align: left;
  font-family: SourceHanSansCN-Regular;
  color: #808080;
  font-size: 14px;
  margin-bottom: 25px;
}
.cssOrderInfoDetail:last-child {
  margin-bottom: 0px;
}
.cssOrderInfoPayDetail {
  vertical-align: top;
  display: inline-block;
  height: 13px;
  width: 126.5px;
  text-align: left;
  font-family: SourceHanSansCN-Regular;
  color: #333333;
  font-size: 13px;
  margin-bottom: 25px;
}
.cssOrderInfoPayDetail:last-child {
  margin-bottom: 0px;
}
.cssInnerText {
  display: inline-block;
  width: 218px;
  /* height: 11px; */
  text-align: left;
  font-family: SourceHanSansCN-Regular;
  color: #333333;
  font-size: 14px;
}
.cssInnerPayText {
  display: inline-block;
  width: 218px;
  /* height: 11px; */
  text-align: right;
  font-family: SourceHanSansCN-Regular;
  color: #c41335;
  font-size: 13px;
}

.cssServeInfo {
  width: 100%;
  /* height: 171.5px; */
  background: #ffffff;
  padding: 20px 15px 20px 15px;
  margin: 0 0 10px 0;
  font-size: 0;
}
.cssServeInfo .cssOrderInfoTit {
  display: block;
  height: 14.5px;
  width: 100%;
  text-align: left;
  font-family: SourceHanSansCN-Bold;
  font-weight: bold;
  color: #000;
  font-size: 15px;
  margin-bottom: 28.5px;
}
.cssNeedInfo {
  width: 100%;
  /* height: 171.5px; */
  background: #ffffff;
  padding: 20px 15px 20px 15px;
  margin: 0 0 10px 0;
  font-size: 0;
}
.cssNeedInfo .cssOrderInfoTit {
  display: block;
  height: 14.5px;
  width: 100%;
  text-align: left;
  font-family: SourceHanSansCN-Bold;
  font-weight: bold;
  color: #000;
  font-size: 15px;
  margin-bottom: 15px;
}
.cssBlankArea {
  height: 146px;
}
.cssContract {
  width: 100%;
  /* height: 171.5px; */
  background: #ffffff;
  padding: 20px 15px 20px 15px;
  margin: 0 0 10px 0;
  font-size: 0;
}
.cssContract .cssOrderInfoTit {
  display: block;
  height: 14.5px;
  width: 100%;
  text-align: left;
  font-family: SourceHanSansCN-Bold;
  font-weight: bold;
  color: #000;
  font-size: 15px;
  margin-bottom: 28.5px;
}
.cssPayBottomDetail {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 146px;
  background: #ffffff;
}
.cssPayBottomDetail .cssUparea {
  padding: 15px 15px 0px 15px;
}
.cssPayBottomDetail .cssOrderInfoPayDetail {
  height: auto;
  margin: 0;
}
.cssPayBottomDetail .cssButtonArea {
  margin-top: 14.5px;
  border-top: 1px solid #eeeeee;
  width: 100%;
  text-align: right;
  padding: 0 15px 0 15px;
}
.cssPayBottomDetail .cssButtonArea .cssAllAmount {
  display: inline-block;
  width: 218px;
  line-height: 60px;
  text-align: right;
  font-family: SourceHanSansCN-Regular;
  color: #333333;
  font-size: 12px;
}
.cssPayBottomDetail .cssButtonArea .cssAllAmount .cssPrice {
  display: inline-block;
  font-family: SourceHanSansCN-Regular;
  color: #c41335;
  font-size: 14px;
  font-weight: bold;
}
.cssPayBottomDetail .cssButtonArea .cssPay {
  display: inline-block;
  height: 45px;
  width: 94.35px;
  text-align: center;
  line-height: 45px;
  color: #ffffff;
  font-size: 15px;
  background: #c41335;
  border-radius: 5px;
  margin-left: 9.5px;
  border: 1px solid transparent;
}
/* border: 1px solid transparent; */
</style>



// WEBPACK FOOTER //
// src/view/orderpaydetail.vue